import { render, staticRenderFns } from "./EmailReport.vue?vue&type=template&id=5484ff74&scoped=true&"
import script from "./EmailReport.vue?vue&type=script&lang=js&"
export * from "./EmailReport.vue?vue&type=script&lang=js&"
import style0 from "./EmailReport.vue?vue&type=style&index=0&id=5484ff74&lang=scss&scoped=true&"
import style1 from "./EmailReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5484ff74",
  null
  
)

export default component.exports